export function productItemTypeLabel(item: any): string {
  const type = item?.originType || item?.issueType;
  return type ? ` (${type})` : "";
}
